import { CALL_API } from '../../util/RBRestMiddleware'
import NgrxAuth from '../../auth/Auth'

export const BENEFITS_LOADING = 'BENEFITS_LOADING'
export const BENEFITS_SUCCESS = 'BENEFITS_SUCCESS'
export const BENEFITS_FAILED = 'BENEFITS_FAILED'

export const fetchBenefits = () => {
  return dispatch => {
    dispatch({
      [CALL_API]: {
        path: `/members/${NgrxAuth.memberId}/benefits`,
        prefix: 'BENEFITS'
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/benefitActions.js